import React, { useEffect, useState } from "react";
import { ReactComponent as Logo } from "../../Assets/Auth/ForgotPassword/Reset.svg";
import OrgLogo from "../../Components/Other/logo";
import { ReactComponent as PasswordLogo } from "../../Assets/Auth/Password.svg";
import Title from "../../Components/Authentication/authTitle";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearErrors, resetPass } from "../../Redux/Actions/authActions";
import CustomAlert from "../../Components/Other/alert";

const ResetPass = () => {
  const [password, setPassword] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [match, setMatch] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {error, success, email} = useSelector(state => state.forgotPass);

  useEffect(() => {
    document.title = "Reset Password";

    if (password && confirmPass && password !== confirmPass) {
        setMatch(false);
        console.log("Passwords do not match");
    } else if(password === confirmPass){
        setMatch(true);
        console.log("Passwords match");
    }

    if(success === true){
      navigate("/password-success");
      dispatch({type: "PASS_RESET"});
    }

    if(error){
      setErrorMessage(error.data.message);
      dispatch(clearErrors());
    }

    if(errorMessage){
      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
    }

  }, [confirmPass, password, error, success, dispatch, navigate, errorMessage]);

  const handleReset = (e) => {
    dispatch(resetPass(email, password));
  }

  const handleNavigate = (e) => {
    e.preventDefault();
    navigate("/");
  }

  return (
    <div className="login-container flex-container flex-center">
      <OrgLogo />
      <div className="mid-container mirror-container">
        <div className="login-form flex-container flex-center flex-column">
          <div className="login-icon-container">
            <Logo className="login-icon" />
          </div>
          <Title title="Set your new password" tagline1="Your passwords should be different from the passwords" tagline2="previously used." />
          <div className="login-input flex-container flex-row">
            <div className="login-input-icon-container">
              <PasswordLogo className="login-input-icon" />
            </div>
            <input
              type="password"
              value={password}
              placeholder="Password"
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
          </div>
          <div className="login-input flex-container flex-row">
            <div className="login-input-icon-container">
              <PasswordLogo className="login-input-icon" />
            </div>
            <input
              type="password"
              value={confirmPass}
              placeholder="Confirm Password"
              onChange={(e) => {
                setConfirmPass(e.target.value);
              }}
            />
          </div>
          <div className="warning-text width-100">
          {match ? null : <p>Passwords do not match</p>}
          </div>
          <div className="login-forgot">
            <Link onClick={handleNavigate}>Return to sign in screen</Link>
          </div>
          <div className="login-button width-100">
            <button
              onClick={handleReset}
              {...(match ? { disabled: false } : {disabled: true}) }
              className="width-100 alt-black font-white font-SemiBold border-15"
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
      <CustomAlert errorMessage = {errorMessage ? errorMessage : ''} />
    </div>
  );
};

export default ResetPass;
